import { createRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { LoginForm } from "@/components/auth/login-form";
import { Route as rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: (search: Record<string, unknown>) => ({
    error: (search.error as string) || undefined,
  }),
  component: LoginPage,
});

const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  unable_to_create_user: "Your account is not authorized to access this application.",
  oauth_provider_not_found: "Sign-in provider not available. Please try again.",
  unable_to_get_user_info: "Could not retrieve your account info from Google.",
};

function LoginPage() {
  const navigate = useNavigate();
  const { error } = useSearch({ from: "/" });
  const { data: session, isPending } = useSession();

  if (isPending) return null;

  if (session?.user) {
    const isAdmin = (session.user as any).role === "admin";
    navigate({ to: isAdmin ? "/deal-metrics" : "/my-dashboard" });
    return null;
  }

  const oauthError = error
    ? (OAUTH_ERROR_MESSAGES[error] ?? "Sign-in failed. Please try again.")
    : undefined;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
      {/* Left panel - brand showcase (desktop only) */}
      <div className="hidden lg:flex flex-col items-center justify-center bg-brand-navy text-white p-12">
        <img
          src="/assets/logo-whitegold.png"
          alt="The Faithful Platform"
          className="max-w-md w-full"
        />
      </div>
      {/* Right panel - login form */}
      <div className="flex items-center justify-center p-8">
        <LoginForm
          onSuccess={() => {
            // Reload to pick up the new session — the redirect logic above
            // will route to the correct page based on role
            window.location.href = "/";
          }}
          oauthError={oauthError}
        />
      </div>
    </div>
  );
}
